import { render, staticRenderFns } from "./partLogo.vue?vue&type=template&id=7a97cf2c&scoped=true&"
import script from "./partLogo.vue?vue&type=script&lang=js&"
export * from "./partLogo.vue?vue&type=script&lang=js&"
import style0 from "./partLogo.vue?vue&type=style&index=0&id=7a97cf2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a97cf2c",
  null
  
)

export default component.exports